export const formatNumber = (num: number, maxDp = 6): string => {
  // Kill FP noise first (e.g., 0.15000000000000002)
  const s = num.toFixed(maxDp); // "1.00", "0.50", "0.15"
  const [i, d] = s.split(".");
  if (!d) return `${i}.0`;                 // no decimal part? add ".0"
  if (/^0+$/.test(d)) return `${i}.0`;     // all zeros -> keep single .0
  return `${i}.${d.replace(/0+$/, "")}`;   // trim trailing zeros
};
